import { render, staticRenderFns } from "./DragAndDropValues.vue?vue&type=template&id=15657590"
import script from "./DragAndDropValues.vue?vue&type=script&lang=js"
export * from "./DragAndDropValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DragAndDropValues.vue?vue&type=custom&index=0&blockType=stype&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports